<template>
  <div class="internet">
    <internetPc v-if="!_isMobile"></internetPc>
    <internetMobile v-else></internetMobile>
    <customizedService v-if="!_isMobile" text="多家知名互联网企业的" colorText="依赖伙伴"></customizedService>
  </div>
</template>
<script>
  import internetPc from './pc/internetPc.vue'
  import internetMobile from './mobile/internetMobile.vue'
  import customizedService from '@/components/customizedServicePc'
  export default {
    metaInfo(){
      return {
        meta:[
          {
            name: 'title',
            content: '优加健保健康科技 ( 北京 ) 有限公司'
          },
          {
            name:'keywords',
            content:'优加健康,优加健保健康科技 ( 北京 ) 有限公司,医疗保险,创新医疗险,技术团队'
          },
          {
            name: 'description',
            content: '优加健康 一支既懂医疗又懂保险的专业化团队 针对创新医疗险的产品/服务创新和落地能力,服务覆盖百万人群。 针对商保的医疗式专家型管理服务团队,行业权威协会和专业院校共同培训及认证。 精通健康险及互联网数据运营的产品及技术团队。'
          }
        ]
      }
    },
    data() {
      return {
        _isMobile: false
      }
    },
    components: {
      internetPc,
      internetMobile,
      customizedService
    },
    created() {
      this._isMobile = this.$util._isMobile()
    },
  }
</script>

<style lang="less" scoped>
  .internet {
    .made {
      width: 100%;

      img {
        width: 100%;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/internet.vue